import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Master from '../views/Master.vue'

Vue.use(VueRouter)
const Financials = () => import('../views/Financials.vue')
const RightmoveRoI = () => import('../views/RightmoveRoI.vue')
const Settings = () => import('../views/Settings.vue')
  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/ownerapp',
    redirect: '/financials',
    name: 'ownerapp',
    component: Master,
    meta: { requiresAuth: true},
    children: [
      {
        path: '/financials',
        name: 'Financials',
        component: Financials
      },
      {
        path: '/rightmoveanalytics',
        name: 'RightmoveRoI',
        component: RightmoveRoI
      },
      {
        path: '/settings',
        name: 'Settings',
        component: Settings
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
